[
	{
		"artsuch": "Deckel",
		"betaufnr": 129001,
		"kdnr": 12346,
		"artnr": "5123438",
		"Analysis_No": "129001",
		"Parts_on_Filter": 3.0,
		"Component_Surface_Area_cm2": 35.28,
		"Weight_mg": 1.21,
		"Date_of_arrival": "2021-08-01T15:00:00",
		"Date_of_Extraction": "2021-08-01T15:00:00",
		"Date_of_Analysis": "2021-08-01T15:00:00",
		"Component": "Deckel",
		"Component_No": "XYZ",
		"Testing_Specification": "5123438",
		"customer_no": "12346",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i. O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,4 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.737377,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 12815.0,
		"woF_15_25": 6114.0,
		"woF_25_50": 3342.0,
		"woF_50_100": 1152.0,
		"woF_100_150": 276.0,
		"woF_150_200": 107.0,
		"woF_200_400": 80.0,
		"woF_400_600": 11.0,
		"woF_600_1000": 8.0,
		"woF_gt_1000": 1.0,
		"woF_200_300": 62.0,
		"woF_300_400": 18.0,
		"woF_400_500": 6.0,
		"woF_500_600": 5.0,
		"woF_600_700": 2.0,
		"woF_700_800": 4.0,
		"woF_800_900": 2.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 1.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 12815.0,
		"All_15_25": 6114.0,
		"All_25_50": 3342.0,
		"All_50_100": 1152.0,
		"All_100_150": 281.0,
		"All_150_200": 109.0,
		"All_200_400": 123.0,
		"All_400_600": 32.0,
		"All_600_1000": 14.0,
		"All_gt_1000": 7.0,
		"All_200_300": 93.0,
		"All_300_400": 30.0,
		"All_400_500": 19.0,
		"All_500_600": 13.0,
		"All_600_700": 2.0,
		"All_700_800": 7.0,
		"All_800_900": 4.0,
		"All_900_1000": 1.0,
		"All_1000_1500": 2.0,
		"All_1500_2000": 4.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 1.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 47.0,
		"Met_15_25": 186.0,
		"Met_25_50": 253.0,
		"Met_50_100": 193.0,
		"Met_100_150": 63.0,
		"Met_150_200": 38.0,
		"Met_200_400": 35.0,
		"Met_400_600": 10.0,
		"Met_600_1000": 5.0,
		"Met_gt_1000": 1.0,
		"Met_200_300": 23.0,
		"Met_300_400": 12.0,
		"Met_400_500": 6.0,
		"Met_500_600": 4.0,
		"Met_600_700": 1.0,
		"Met_700_800": 2.0,
		"Met_800_900": 2.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 1.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 734.0,
		"woFNM_1W": 253.0,
		"woFNM_2L": 731.0,
		"woFNM_2W": 156.0,
		"woFNM_3L": 672.0,
		"woFNM_3W": 156.0,
		"woFNM_4L": 533.0,
		"woFNM_4W": 79.0,
		"woFNM_5L": 386.0,
		"woFNM_5W": 43.0,
		"Met_1L": 1665.0,
		"Met_1W": 801.0,
		"Met_2L": 896.0,
		"Met_2W": 102.0,
		"Met_3L": 885.0,
		"Met_3W": 349.0,
		"Met_4L": 793.0,
		"Met_4W": 192.0,
		"Met_5L": 789.0,
		"Met_5W": 387.0,
		"Fib_Fmax1_Fmax": 2861.0,
		"Fib_Fmax1_Lstr": 3819.0,
		"Fib_Fmax2_Fmax": 1903.0,
		"Fib_Fmax2_Lstr": 2599.0,
		"Fib_Lstr1_Fmax": 2861.0,
		"Fib_Lstr1_Lstr": 3819.0,
		"Fib_Fmax_Sum_um": 38695.0,
		"Fib_Stretched_Sum_um": 49226.0,
		"woF_weighted_sum": 6755.0,
		"All_weighted_sum": 12089.0,
		"Met_weighted_sum": 3107.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 129001,
		"Passed": "0",
		"zeichnr": "Deckel",
		"met_sum": 345.0,
		"nm_sum": 1290.0,
		"sum_fibers": 83.0,
		"fibers_sum": 83.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Deckel",
		"betaufnr": 129002,
		"kdnr": 12346,
		"artnr": "5123438",
		"Analysis_No": "129002",
		"Parts_on_Filter": 3.0,
		"Component_Surface_Area_cm2": 35.28,
		"Weight_mg": 1.21,
		"Date_of_arrival": "2021-08-02T15:00:00",
		"Date_of_Extraction": "2021-08-02T15:00:00",
		"Date_of_Analysis": "2021-08-02T15:00:00",
		"Component": "Deckel",
		"Component_No": "XYZ",
		"Testing_Specification": "5123438",
		"customer_no": "12346",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i. O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,4 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 1.091838,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 19283.0,
		"woF_15_25": 9165.0,
		"woF_25_50": 4878.0,
		"woF_50_100": 1880.0,
		"woF_100_150": 479.0,
		"woF_150_200": 159.0,
		"woF_200_400": 110.0,
		"woF_400_600": 11.0,
		"woF_600_1000": 8.0,
		"woF_gt_1000": 1.0,
		"woF_200_300": 1.0,
		"woF_300_400": null,
		"woF_400_500": 9.0,
		"woF_500_600": 2.0,
		"woF_600_700": 4.0,
		"woF_700_800": 2.0,
		"woF_800_900": 2.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 1.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 19283.0,
		"All_15_25": 9165.0,
		"All_25_50": 4878.0,
		"All_50_100": 1880.0,
		"All_100_150": 489.0,
		"All_150_200": 166.0,
		"All_200_400": 185.0,
		"All_400_600": 40.0,
		"All_600_1000": 36.0,
		"All_gt_1000": 7.0,
		"All_200_300": 7.0,
		"All_300_400": null,
		"All_400_500": 30.0,
		"All_500_600": 10.0,
		"All_600_700": 18.0,
		"All_700_800": 13.0,
		"All_800_900": 4.0,
		"All_900_1000": 1.0,
		"All_1000_1500": 3.0,
		"All_1500_2000": 1.0,
		"All_2000_2500": 1.0,
		"All_2500_3000": 2.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 32.0,
		"Met_15_25": 109.0,
		"Met_25_50": 183.0,
		"Met_50_100": 235.0,
		"Met_100_150": 89.0,
		"Met_150_200": 25.0,
		"Met_200_400": 23.0,
		"Met_400_600": 4.0,
		"Met_600_1000": 6.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 0.0,
		"Met_300_400": null,
		"Met_400_500": 2.0,
		"Met_500_600": 2.0,
		"Met_600_700": 2.0,
		"Met_700_800": 2.0,
		"Met_800_900": 2.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 2681.0,
		"woFNM_1W": 465.0,
		"woFNM_2L": 609.0,
		"woFNM_2W": 150.0,
		"woFNM_3L": 601.0,
		"woFNM_3W": 119.0,
		"woFNM_4L": 472.0,
		"woFNM_4W": 60.0,
		"woFNM_5L": 466.0,
		"woFNM_5W": 129.0,
		"Met_1L": 835.0,
		"Met_1W": 653.0,
		"Met_2L": 822.0,
		"Met_2W": 107.0,
		"Met_3L": 797.0,
		"Met_3W": 312.0,
		"Met_4L": 752.0,
		"Met_4W": 435.0,
		"Met_5L": 602.0,
		"Met_5W": 331.0,
		"Fib_Fmax1_Fmax": 2542.0,
		"Fib_Fmax1_Lstr": 5950.0,
		"Fib_Fmax2_Fmax": 2165.0,
		"Fib_Fmax2_Lstr": 2710.0,
		"Fib_Lstr1_Fmax": 2542.0,
		"Fib_Lstr1_Lstr": 5950.0,
		"Fib_Fmax_Sum_um": 66956.0,
		"Fib_Stretched_Sum_um": 84235.0,
		"woF_weighted_sum": 9243.0,
		"All_weighted_sum": 18834.0,
		"Met_weighted_sum": 2304.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 129002,
		"Passed": "1",
		"zeichnr": "Deckel",
		"met_sum": 382.0,
		"nm_sum": 2266.0,
		"sum_fibers": 154.0,
		"fibers_sum": 154.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Deckel",
		"betaufnr": 129003,
		"kdnr": 12346,
		"artnr": "5123438",
		"Analysis_No": "129003",
		"Parts_on_Filter": 3.0,
		"Component_Surface_Area_cm2": 35.28,
		"Weight_mg": 1.13,
		"Date_of_arrival": "2021-08-03T15:00:00",
		"Date_of_Extraction": "2021-08-03T15:00:00",
		"Date_of_Analysis": "2021-08-03T15:00:00",
		"Component": "Deckel",
		"Component_No": "XYZ",
		"Testing_Specification": "5123438",
		"customer_no": "12346",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i. O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,4 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 1.005447,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 16747.0,
		"woF_15_25": 8528.0,
		"woF_25_50": 4868.0,
		"woF_50_100": 1894.0,
		"woF_100_150": 477.0,
		"woF_150_200": 204.0,
		"woF_200_400": 135.0,
		"woF_400_600": 13.0,
		"woF_600_1000": 4.0,
		"woF_gt_1000": 1.0,
		"woF_200_300": 1.0,
		"woF_300_400": null,
		"woF_400_500": 10.0,
		"woF_500_600": 3.0,
		"woF_600_700": 1.0,
		"woF_700_800": 2.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 1.0,
		"woF_1000_1500": 1.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 16747.0,
		"All_15_25": 8528.0,
		"All_25_50": 4868.0,
		"All_50_100": 1894.0,
		"All_100_150": 487.0,
		"All_150_200": 210.0,
		"All_200_400": 207.0,
		"All_400_600": 36.0,
		"All_600_1000": 31.0,
		"All_gt_1000": 10.0,
		"All_200_300": 10.0,
		"All_300_400": null,
		"All_400_500": 25.0,
		"All_500_600": 11.0,
		"All_600_700": 9.0,
		"All_700_800": 10.0,
		"All_800_900": 10.0,
		"All_900_1000": 2.0,
		"All_1000_1500": 6.0,
		"All_1500_2000": 3.0,
		"All_2000_2500": 1.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 24.0,
		"Met_15_25": 115.0,
		"Met_25_50": 237.0,
		"Met_50_100": 194.0,
		"Met_100_150": 89.0,
		"Met_150_200": 49.0,
		"Met_200_400": 52.0,
		"Met_400_600": 7.0,
		"Met_600_1000": 3.0,
		"Met_gt_1000": 1.0,
		"Met_200_300": 1.0,
		"Met_300_400": null,
		"Met_400_500": 5.0,
		"Met_500_600": 2.0,
		"Met_600_700": 1.0,
		"Met_700_800": 1.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 1.0,
		"Met_1000_1500": 1.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 792.0,
		"woFNM_1W": 118.0,
		"woFNM_2L": 566.0,
		"woFNM_2W": 222.0,
		"woFNM_3L": 460.0,
		"woFNM_3W": 103.0,
		"woFNM_4L": 456.0,
		"woFNM_4W": 75.0,
		"woFNM_5L": 436.0,
		"woFNM_5W": 65.0,
		"Met_1L": 1126.0,
		"Met_1W": 355.0,
		"Met_2L": 980.0,
		"Met_2W": 148.0,
		"Met_3L": 711.0,
		"Met_3W": 140.0,
		"Met_4L": 633.0,
		"Met_4W": 124.0,
		"Met_5L": 567.0,
		"Met_5W": 107.0,
		"Fib_Fmax1_Fmax": 2341.0,
		"Fib_Fmax1_Lstr": 3105.0,
		"Fib_Fmax2_Fmax": 1860.0,
		"Fib_Fmax2_Lstr": 2142.0,
		"Fib_Lstr1_Fmax": 2341.0,
		"Fib_Lstr1_Lstr": 3105.0,
		"Fib_Fmax_Sum_um": 67480.0,
		"Fib_Stretched_Sum_um": 85372.0,
		"woF_weighted_sum": 9606.0,
		"All_weighted_sum": 19812.0,
		"Met_weighted_sum": 3103.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 129003,
		"Passed": "0",
		"zeichnr": "Deckel",
		"met_sum": 395.0,
		"nm_sum": 2333.0,
		"sum_fibers": 146.0,
		"fibers_sum": 146.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Deckel",
		"betaufnr": 129004,
		"kdnr": 12346,
		"artnr": "5123438",
		"Analysis_No": "129004",
		"Parts_on_Filter": 3.0,
		"Component_Surface_Area_cm2": 35.28,
		"Weight_mg": 0.28,
		"Date_of_arrival": "2021-08-04T15:00:00",
		"Date_of_Extraction": "2021-08-04T15:00:00",
		"Date_of_Analysis": "2021-08-04T15:00:00",
		"Component": "Deckel",
		"Component_No": "XYZ",
		"Testing_Specification": "5123438",
		"customer_no": "12346",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,4 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.288282,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 6898.0,
		"woF_15_25": 3946.0,
		"woF_25_50": 1900.0,
		"woF_50_100": 463.0,
		"woF_100_150": 71.0,
		"woF_150_200": 35.0,
		"woF_200_400": 24.0,
		"woF_400_600": 2.0,
		"woF_600_1000": 4.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 0.0,
		"woF_300_400": null,
		"woF_400_500": 1.0,
		"woF_500_600": 1.0,
		"woF_600_700": 2.0,
		"woF_700_800": 2.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 6898.0,
		"All_15_25": 3946.0,
		"All_25_50": 1900.0,
		"All_50_100": 463.0,
		"All_100_150": 72.0,
		"All_150_200": 35.0,
		"All_200_400": 42.0,
		"All_400_600": 9.0,
		"All_600_1000": 9.0,
		"All_gt_1000": 1.0,
		"All_200_300": 1.0,
		"All_300_400": null,
		"All_400_500": 3.0,
		"All_500_600": 6.0,
		"All_600_700": 4.0,
		"All_700_800": 3.0,
		"All_800_900": 1.0,
		"All_900_1000": 1.0,
		"All_1000_1500": 1.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 39.0,
		"Met_15_25": 134.0,
		"Met_25_50": 107.0,
		"Met_50_100": 76.0,
		"Met_100_150": 22.0,
		"Met_150_200": 13.0,
		"Met_200_400": 8.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 4.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 0.0,
		"Met_300_400": null,
		"Met_400_500": 0.0,
		"Met_500_600": 0.0,
		"Met_600_700": 2.0,
		"Met_700_800": 2.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 535.0,
		"woFNM_1W": 118.0,
		"woFNM_2L": 473.0,
		"woFNM_2W": 113.0,
		"woFNM_3L": 399.0,
		"woFNM_3W": 102.0,
		"woFNM_4L": 345.0,
		"woFNM_4W": 39.0,
		"woFNM_5L": 317.0,
		"woFNM_5W": 48.0,
		"Met_1L": 760.0,
		"Met_1W": 59.0,
		"Met_2L": 743.0,
		"Met_2W": 64.0,
		"Met_3L": 684.0,
		"Met_3W": 75.0,
		"Met_4L": 606.0,
		"Met_4W": 27.0,
		"Met_5L": 303.0,
		"Met_5W": 123.0,
		"Fib_Fmax1_Fmax": 1209.0,
		"Fib_Fmax1_Lstr": 1641.0,
		"Fib_Fmax2_Fmax": 983.0,
		"Fib_Fmax2_Lstr": 1147.0,
		"Fib_Lstr1_Fmax": 1209.0,
		"Fib_Lstr1_Lstr": 1641.0,
		"Fib_Fmax_Sum_um": 14433.0,
		"Fib_Stretched_Sum_um": 17326.0,
		"woF_weighted_sum": 2150.0,
		"All_weighted_sum": 4010.0,
		"Met_weighted_sum": 985.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 129004,
		"Passed": "1",
		"zeichnr": "Deckel",
		"met_sum": 123.0,
		"nm_sum": 476.0,
		"sum_fibers": 32.0,
		"fibers_sum": 32.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Deckel",
		"betaufnr": 129005,
		"kdnr": 12346,
		"artnr": "5123438",
		"Analysis_No": "129005",
		"Parts_on_Filter": 3.0,
		"Component_Surface_Area_cm2": 35.28,
		"Weight_mg": 0.22,
		"Date_of_arrival": "2021-08-05T15:00:00",
		"Date_of_Extraction": "2021-08-05T15:00:00",
		"Date_of_Analysis": "2021-08-05T15:00:00",
		"Component": "Deckel",
		"Component_No": "XYZ",
		"Testing_Specification": "5123438",
		"customer_no": "12346",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,4 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.375536,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 8898.0,
		"woF_15_25": 4907.0,
		"woF_25_50": 2424.0,
		"woF_50_100": 679.0,
		"woF_100_150": 122.0,
		"woF_150_200": 45.0,
		"woF_200_400": 22.0,
		"woF_400_600": 2.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 0.0,
		"woF_300_400": null,
		"woF_400_500": 1.0,
		"woF_500_600": 1.0,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 8898.0,
		"All_15_25": 4907.0,
		"All_25_50": 2424.0,
		"All_50_100": 679.0,
		"All_100_150": 122.0,
		"All_150_200": 45.0,
		"All_200_400": 36.0,
		"All_400_600": 7.0,
		"All_600_1000": 3.0,
		"All_gt_1000": 4.0,
		"All_200_300": 4.0,
		"All_300_400": null,
		"All_400_500": 3.0,
		"All_500_600": 4.0,
		"All_600_700": 0.0,
		"All_700_800": 1.0,
		"All_800_900": 2.0,
		"All_900_1000": 0.0,
		"All_1000_1500": 2.0,
		"All_1500_2000": 2.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 28.0,
		"Met_15_25": 165.0,
		"Met_25_50": 160.0,
		"Met_50_100": 82.0,
		"Met_100_150": 37.0,
		"Met_150_200": 20.0,
		"Met_200_400": 8.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 0.0,
		"Met_300_400": null,
		"Met_400_500": 0.0,
		"Met_500_600": 0.0,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 564.0,
		"woFNM_1W": 91.0,
		"woFNM_2L": 404.0,
		"woFNM_2W": 64.0,
		"woFNM_3L": 393.0,
		"woFNM_3W": 93.0,
		"woFNM_4L": 291.0,
		"woFNM_4W": 129.0,
		"woFNM_5L": 272.0,
		"woFNM_5W": 39.0,
		"Met_1L": 338.0,
		"Met_1W": 83.0,
		"Met_2L": 287.0,
		"Met_2W": 51.0,
		"Met_3L": 246.0,
		"Met_3W": 48.0,
		"Met_4L": 239.0,
		"Met_4W": 27.0,
		"Met_5L": 227.0,
		"Met_5W": 27.0,
		"Fib_Fmax1_Fmax": 1796.0,
		"Fib_Fmax1_Lstr": 1819.0,
		"Fib_Fmax2_Fmax": 1521.0,
		"Fib_Fmax2_Lstr": 2458.0,
		"Fib_Lstr1_Fmax": 1521.0,
		"Fib_Lstr1_Lstr": 2458.0,
		"Fib_Fmax_Sum_um": 14719.0,
		"Fib_Stretched_Sum_um": 17309.0,
		"woF_weighted_sum": 2052.0,
		"All_weighted_sum": 4628.0,
		"Met_weighted_sum": 538.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 129005,
		"Passed": "1",
		"zeichnr": "Deckel",
		"met_sum": 147.0,
		"nm_sum": 723.0,
		"sum_fibers": 26.0,
		"fibers_sum": 26.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Deckel",
		"betaufnr": 129006,
		"kdnr": 12346,
		"artnr": "5123438",
		"Analysis_No": "129006",
		"Parts_on_Filter": 3.0,
		"Component_Surface_Area_cm2": 35.28,
		"Weight_mg": 0.31,
		"Date_of_arrival": "2021-08-06T15:00:00",
		"Date_of_Extraction": "2021-08-06T15:00:00",
		"Date_of_Analysis": "2021-08-06T15:00:00",
		"Component": "Deckel",
		"Component_No": "XYZ",
		"Testing_Specification": "5123438",
		"customer_no": "12346",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,4 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.408578,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 8114.0,
		"woF_15_25": 5516.0,
		"woF_25_50": 2837.0,
		"woF_50_100": 731.0,
		"woF_100_150": 138.0,
		"woF_150_200": 40.0,
		"woF_200_400": 30.0,
		"woF_400_600": 5.0,
		"woF_600_1000": 1.0,
		"woF_gt_1000": 1.0,
		"woF_200_300": 1.0,
		"woF_300_400": null,
		"woF_400_500": 4.0,
		"woF_500_600": 1.0,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 1.0,
		"woF_1000_1500": 1.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 8114.0,
		"All_15_25": 5516.0,
		"All_25_50": 2837.0,
		"All_50_100": 731.0,
		"All_100_150": 138.0,
		"All_150_200": 41.0,
		"All_200_400": 39.0,
		"All_400_600": 8.0,
		"All_600_1000": 1.0,
		"All_gt_1000": 1.0,
		"All_200_300": 1.0,
		"All_300_400": null,
		"All_400_500": 6.0,
		"All_500_600": 2.0,
		"All_600_700": 0.0,
		"All_700_800": 0.0,
		"All_800_900": 0.0,
		"All_900_1000": 1.0,
		"All_1000_1500": 1.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 42.0,
		"Met_15_25": 264.0,
		"Met_25_50": 264.0,
		"Met_50_100": 139.0,
		"Met_100_150": 47.0,
		"Met_150_200": 26.0,
		"Met_200_400": 25.0,
		"Met_400_600": 5.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 1.0,
		"Met_200_300": 1.0,
		"Met_300_400": null,
		"Met_400_500": 4.0,
		"Met_500_600": 1.0,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 1.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 948.0,
		"woFNM_1W": 322.0,
		"woFNM_2L": 335.0,
		"woFNM_2W": 27.0,
		"woFNM_3L": 264.0,
		"woFNM_3W": 27.0,
		"woFNM_4L": 218.0,
		"woFNM_4W": 86.0,
		"woFNM_5L": 204.0,
		"woFNM_5W": 54.0,
		"Met_1L": 1291.0,
		"Met_1W": 150.0,
		"Met_2L": 560.0,
		"Met_2W": 97.0,
		"Met_3L": 464.0,
		"Met_3W": 64.0,
		"Met_4L": 437.0,
		"Met_4W": 81.0,
		"Met_5L": 430.0,
		"Met_5W": 31.0,
		"Fib_Fmax1_Fmax": 575.0,
		"Fib_Fmax1_Lstr": 591.0,
		"Fib_Fmax2_Fmax": 496.0,
		"Fib_Fmax2_Lstr": 566.0,
		"Fib_Lstr1_Fmax": 575.0,
		"Fib_Lstr1_Lstr": 591.0,
		"Fib_Fmax_Sum_um": 4098.0,
		"Fib_Stretched_Sum_um": 4896.0,
		"woF_weighted_sum": 2987.0,
		"All_weighted_sum": 3332.0,
		"Met_weighted_sum": 1681.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 129006,
		"Passed": "1",
		"zeichnr": "Deckel",
		"met_sum": 243.0,
		"nm_sum": 703.0,
		"sum_fibers": 13.0,
		"fibers_sum": 13.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Deckel",
		"betaufnr": 129007,
		"kdnr": 12346,
		"artnr": "5123438",
		"Analysis_No": "129007",
		"Parts_on_Filter": 3.0,
		"Component_Surface_Area_cm2": 35.28,
		"Weight_mg": 0.26,
		"Date_of_arrival": "2021-08-07T15:00:00",
		"Date_of_Extraction": "2021-08-07T15:00:00",
		"Date_of_Analysis": "2021-08-07T15:00:00",
		"Component": "Deckel",
		"Component_No": "XYZ",
		"Testing_Specification": "5123438",
		"customer_no": "12346",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,4 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.597569,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 9568.0,
		"woF_15_25": 5603.0,
		"woF_25_50": 2902.0,
		"woF_50_100": 959.0,
		"woF_100_150": 225.0,
		"woF_150_200": 82.0,
		"woF_200_400": 53.0,
		"woF_400_600": 3.0,
		"woF_600_1000": 2.0,
		"woF_gt_1000": 1.0,
		"woF_200_300": 1.0,
		"woF_300_400": null,
		"woF_400_500": 2.0,
		"woF_500_600": 1.0,
		"woF_600_700": 1.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 1.0,
		"woF_1000_1500": 1.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 9568.0,
		"All_15_25": 5603.0,
		"All_25_50": 2902.0,
		"All_50_100": 959.0,
		"All_100_150": 228.0,
		"All_150_200": 83.0,
		"All_200_400": 69.0,
		"All_400_600": 8.0,
		"All_600_1000": 11.0,
		"All_gt_1000": 5.0,
		"All_200_300": 5.0,
		"All_300_400": null,
		"All_400_500": 5.0,
		"All_500_600": 3.0,
		"All_600_700": 7.0,
		"All_700_800": 2.0,
		"All_800_900": 0.0,
		"All_900_1000": 2.0,
		"All_1000_1500": 5.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 76.0,
		"Met_15_25": 186.0,
		"Met_25_50": 219.0,
		"Met_50_100": 115.0,
		"Met_100_150": 73.0,
		"Met_150_200": 31.0,
		"Met_200_400": 22.0,
		"Met_400_600": 0.0,
		"Met_600_1000": 2.0,
		"Met_gt_1000": 1.0,
		"Met_200_300": 1.0,
		"Met_300_400": null,
		"Met_400_500": 0.0,
		"Met_500_600": 0.0,
		"Met_600_700": 1.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 1.0,
		"Met_1000_1500": 1.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 545.0,
		"woFNM_1W": 172.0,
		"woFNM_2L": 452.0,
		"woFNM_2W": 48.0,
		"woFNM_3L": 426.0,
		"woFNM_3W": 38.0,
		"woFNM_4L": 360.0,
		"woFNM_4W": 124.0,
		"woFNM_5L": 339.0,
		"woFNM_5W": 81.0,
		"Met_1L": 1329.0,
		"Met_1W": 571.0,
		"Met_2L": 918.0,
		"Met_2W": 271.0,
		"Met_3L": 664.0,
		"Met_3W": 96.0,
		"Met_4L": 354.0,
		"Met_4W": 96.0,
		"Met_5L": 352.0,
		"Met_5W": 172.0,
		"Fib_Fmax1_Fmax": 1394.0,
		"Fib_Fmax1_Lstr": 1781.0,
		"Fib_Fmax2_Fmax": 1294.0,
		"Fib_Fmax2_Lstr": 1701.0,
		"Fib_Lstr1_Fmax": 1092.0,
		"Fib_Lstr1_Lstr": 3446.0,
		"Fib_Fmax_Sum_um": 19547.0,
		"Fib_Stretched_Sum_um": 26016.0,
		"woF_weighted_sum": 4325.0,
		"All_weighted_sum": 7818.0,
		"Met_weighted_sum": 1726.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 129007,
		"Passed": "1",
		"zeichnr": "Deckel",
		"met_sum": 244.0,
		"nm_sum": 1081.0,
		"sum_fibers": 38.0,
		"fibers_sum": 38.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Deckel",
		"betaufnr": 129008,
		"kdnr": 12346,
		"artnr": "5123438",
		"Analysis_No": "129008",
		"Parts_on_Filter": 3.0,
		"Component_Surface_Area_cm2": 35.28,
		"Weight_mg": 0.13,
		"Date_of_arrival": "2021-08-08T15:00:00",
		"Date_of_Extraction": "2021-08-08T15:00:00",
		"Date_of_Analysis": "2021-08-08T15:00:00",
		"Component": "Deckel",
		"Component_No": "XYZ",
		"Testing_Specification": "5123438",
		"customer_no": "12346",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,4 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.478533,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 8383.0,
		"woF_15_25": 4876.0,
		"woF_25_50": 2951.0,
		"woF_50_100": 1059.0,
		"woF_100_150": 222.0,
		"woF_150_200": 87.0,
		"woF_200_400": 60.0,
		"woF_400_600": 4.0,
		"woF_600_1000": 1.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 0.0,
		"woF_300_400": null,
		"woF_400_500": 2.0,
		"woF_500_600": 2.0,
		"woF_600_700": 1.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 8383.0,
		"All_15_25": 4876.0,
		"All_25_50": 2951.0,
		"All_50_100": 1059.0,
		"All_100_150": 227.0,
		"All_150_200": 89.0,
		"All_200_400": 77.0,
		"All_400_600": 11.0,
		"All_600_1000": 9.0,
		"All_gt_1000": 3.0,
		"All_200_300": 3.0,
		"All_300_400": null,
		"All_400_500": 7.0,
		"All_500_600": 4.0,
		"All_600_700": 5.0,
		"All_700_800": 2.0,
		"All_800_900": 1.0,
		"All_900_1000": 1.0,
		"All_1000_1500": 3.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 45.0,
		"Met_15_25": 136.0,
		"Met_25_50": 270.0,
		"Met_50_100": 183.0,
		"Met_100_150": 84.0,
		"Met_150_200": 40.0,
		"Met_200_400": 26.0,
		"Met_400_600": 1.0,
		"Met_600_1000": 1.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 0.0,
		"Met_300_400": null,
		"Met_400_500": 1.0,
		"Met_500_600": 0.0,
		"Met_600_700": 1.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 537.0,
		"woFNM_1W": 113.0,
		"woFNM_2L": 501.0,
		"woFNM_2W": 125.0,
		"woFNM_3L": 442.0,
		"woFNM_3W": 42.0,
		"woFNM_4L": 390.0,
		"woFNM_4W": 70.0,
		"woFNM_5L": 380.0,
		"woFNM_5W": 172.0,
		"Met_1L": 640.0,
		"Met_1W": 113.0,
		"Met_2L": 499.0,
		"Met_2W": 76.0,
		"Met_3L": 397.0,
		"Met_3W": 70.0,
		"Met_4L": 391.0,
		"Met_4W": 70.0,
		"Met_5L": 389.0,
		"Met_5W": 133.0,
		"Fib_Fmax1_Fmax": 1230.0,
		"Fib_Fmax1_Lstr": 1589.0,
		"Fib_Fmax2_Fmax": 1128.0,
		"Fib_Fmax2_Lstr": 1524.0,
		"Fib_Lstr1_Fmax": 1230.0,
		"Fib_Lstr1_Lstr": 1589.0,
		"Fib_Fmax_Sum_um": 18269.0,
		"Fib_Stretched_Sum_um": 21062.0,
		"woF_weighted_sum": 4090.0,
		"All_weighted_sum": 7200.0,
		"Met_weighted_sum": 1503.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 129008,
		"Passed": "1",
		"zeichnr": "Deckel",
		"met_sum": 335.0,
		"nm_sum": 1098.0,
		"sum_fibers": 42.0,
		"fibers_sum": 42.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Deckel",
		"betaufnr": 129009,
		"kdnr": 12346,
		"artnr": "5123438",
		"Analysis_No": "129009",
		"Parts_on_Filter": 3.0,
		"Component_Surface_Area_cm2": 35.28,
		"Weight_mg": 0.21,
		"Date_of_arrival": "2021-08-09T15:00:00",
		"Date_of_Extraction": "2021-08-09T15:00:00",
		"Date_of_Analysis": "2021-08-09T15:00:00",
		"Component": "Deckel",
		"Component_No": "XYZ",
		"Testing_Specification": "5123438",
		"customer_no": "12346",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,4 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.585146,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 10106.0,
		"woF_15_25": 6724.0,
		"woF_25_50": 2992.0,
		"woF_50_100": 1010.0,
		"woF_100_150": 239.0,
		"woF_150_200": 87.0,
		"woF_200_400": 64.0,
		"woF_400_600": 5.0,
		"woF_600_1000": 1.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 0.0,
		"woF_300_400": null,
		"woF_400_500": 2.0,
		"woF_500_600": 3.0,
		"woF_600_700": 1.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 10106.0,
		"All_15_25": 6724.0,
		"All_25_50": 2992.0,
		"All_50_100": 1010.0,
		"All_100_150": 242.0,
		"All_150_200": 88.0,
		"All_200_400": 92.0,
		"All_400_600": 19.0,
		"All_600_1000": 10.0,
		"All_gt_1000": 2.0,
		"All_200_300": 2.0,
		"All_300_400": null,
		"All_400_500": 12.0,
		"All_500_600": 7.0,
		"All_600_700": 4.0,
		"All_700_800": 5.0,
		"All_800_900": 0.0,
		"All_900_1000": 1.0,
		"All_1000_1500": 2.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 53.0,
		"Met_15_25": 177.0,
		"Met_25_50": 252.0,
		"Met_50_100": 155.0,
		"Met_100_150": 62.0,
		"Met_150_200": 29.0,
		"Met_200_400": 21.0,
		"Met_400_600": 4.0,
		"Met_600_1000": 1.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 0.0,
		"Met_300_400": null,
		"Met_400_500": 2.0,
		"Met_500_600": 2.0,
		"Met_600_700": 1.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 553.0,
		"woFNM_1W": 317.0,
		"woFNM_2L": 392.0,
		"woFNM_2W": 50.0,
		"woFNM_3L": 374.0,
		"woFNM_3W": 59.0,
		"woFNM_4L": 367.0,
		"woFNM_4W": 48.0,
		"woFNM_5L": 351.0,
		"woFNM_5W": 226.0,
		"Met_1L": 673.0,
		"Met_1W": 322.0,
		"Met_2L": 533.0,
		"Met_2W": 70.0,
		"Met_3L": 503.0,
		"Met_3W": 408.0,
		"Met_4L": 446.0,
		"Met_4W": 64.0,
		"Met_5L": 409.0,
		"Met_5W": 54.0,
		"Fib_Fmax1_Fmax": 1120.0,
		"Fib_Fmax1_Lstr": 1147.0,
		"Fib_Fmax2_Fmax": 1107.0,
		"Fib_Fmax2_Lstr": 1437.0,
		"Fib_Lstr1_Fmax": 1107.0,
		"Fib_Lstr1_Lstr": 1437.0,
		"Fib_Fmax_Sum_um": 23693.0,
		"Fib_Stretched_Sum_um": 27103.0,
		"woF_weighted_sum": 4237.0,
		"All_weighted_sum": 7698.0,
		"Met_weighted_sum": 1400.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 129009,
		"Passed": "1",
		"zeichnr": "Deckel",
		"met_sum": 272.0,
		"nm_sum": 1134.0,
		"sum_fibers": 57.0,
		"fibers_sum": 57.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Deckel",
		"betaufnr": 129010,
		"kdnr": 12346,
		"artnr": "5123438",
		"Analysis_No": "129010",
		"Parts_on_Filter": 3.0,
		"Component_Surface_Area_cm2": 35.28,
		"Weight_mg": 0.89,
		"Date_of_arrival": "2021-08-10T15:00:00",
		"Date_of_Extraction": "2021-08-10T15:00:00",
		"Date_of_Analysis": "2021-08-10T15:00:00",
		"Component": "Deckel",
		"Component_No": "XYZ",
		"Testing_Specification": "5123438",
		"customer_no": "12346",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,4 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.964608,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 16741.0,
		"woF_15_25": 7865.0,
		"woF_25_50": 4436.0,
		"woF_50_100": 1590.0,
		"woF_100_150": 303.0,
		"woF_150_200": 126.0,
		"woF_200_400": 89.0,
		"woF_400_600": 4.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 3.0,
		"woF_200_300": 2.0,
		"woF_300_400": null,
		"woF_400_500": 3.0,
		"woF_500_600": 1.0,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 1.0,
		"woF_1500_2000": 1.0,
		"woF_2000_2500": 1.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 16741.0,
		"All_15_25": 7865.0,
		"All_25_50": 4436.0,
		"All_50_100": 1590.0,
		"All_100_150": 305.0,
		"All_150_200": 131.0,
		"All_200_400": 128.0,
		"All_400_600": 21.0,
		"All_600_1000": 11.0,
		"All_gt_1000": 11.0,
		"All_200_300": 10.0,
		"All_300_400": null,
		"All_400_500": 13.0,
		"All_500_600": 8.0,
		"All_600_700": 6.0,
		"All_700_800": 4.0,
		"All_800_900": 0.0,
		"All_900_1000": 1.0,
		"All_1000_1500": 5.0,
		"All_1500_2000": 5.0,
		"All_2000_2500": 1.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 59.0,
		"Met_15_25": 168.0,
		"Met_25_50": 261.0,
		"Met_50_100": 227.0,
		"Met_100_150": 62.0,
		"Met_150_200": 28.0,
		"Met_200_400": 17.0,
		"Met_400_600": 2.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 1.0,
		"Met_200_300": 1.0,
		"Met_300_400": null,
		"Met_400_500": 1.0,
		"Met_500_600": 1.0,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 1.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 2489.0,
		"woFNM_1W": 2052.0,
		"woFNM_2L": 1317.0,
		"woFNM_2W": 613.0,
		"woFNM_3L": 487.0,
		"woFNM_3W": 189.0,
		"woFNM_4L": 419.0,
		"woFNM_4W": 242.0,
		"woFNM_5L": 395.0,
		"woFNM_5W": 107.0,
		"Met_1L": 1893.0,
		"Met_1W": 564.0,
		"Met_2L": 555.0,
		"Met_2W": 220.0,
		"Met_3L": 406.0,
		"Met_3W": 97.0,
		"Met_4L": 319.0,
		"Met_4W": 75.0,
		"Met_5L": 318.0,
		"Met_5W": 76.0,
		"Fib_Fmax1_Fmax": 1998.0,
		"Fib_Fmax1_Lstr": 2265.0,
		"Fib_Fmax2_Fmax": 1743.0,
		"Fib_Fmax2_Lstr": 1800.0,
		"Fib_Lstr1_Fmax": 1998.0,
		"Fib_Lstr1_Lstr": 2265.0,
		"Fib_Fmax_Sum_um": 40795.0,
		"Fib_Stretched_Sum_um": 46447.0,
		"woF_weighted_sum": 6816.0,
		"All_weighted_sum": 13365.0,
		"Met_weighted_sum": 1527.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 129010,
		"Passed": "1",
		"zeichnr": "Deckel",
		"met_sum": 337.0,
		"nm_sum": 1777.0,
		"sum_fibers": 82.0,
		"fibers_sum": 82.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Deckel",
		"betaufnr": 129011,
		"kdnr": 12346,
		"artnr": "5123438",
		"Analysis_No": "129011",
		"Parts_on_Filter": 3.0,
		"Component_Surface_Area_cm2": 35.28,
		"Weight_mg": 0.54,
		"Date_of_arrival": "2021-08-11T15:00:00",
		"Date_of_Extraction": "2021-08-11T15:00:00",
		"Date_of_Analysis": "2021-08-11T15:00:00",
		"Component": "Deckel",
		"Component_No": "XYZ",
		"Testing_Specification": "5123438",
		"customer_no": "12346",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,4 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.796295,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 13084.0,
		"woF_15_25": 6218.0,
		"woF_25_50": 3555.0,
		"woF_50_100": 1394.0,
		"woF_100_150": 297.0,
		"woF_150_200": 108.0,
		"woF_200_400": 89.0,
		"woF_400_600": 9.0,
		"woF_600_1000": 1.0,
		"woF_gt_1000": 1.0,
		"woF_200_300": 1.0,
		"woF_300_400": null,
		"woF_400_500": 8.0,
		"woF_500_600": 1.0,
		"woF_600_700": 0.0,
		"woF_700_800": 1.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 1.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 13084.0,
		"All_15_25": 6218.0,
		"All_25_50": 3555.0,
		"All_50_100": 1394.0,
		"All_100_150": 299.0,
		"All_150_200": 111.0,
		"All_200_400": 110.0,
		"All_400_600": 27.0,
		"All_600_1000": 21.0,
		"All_gt_1000": 9.0,
		"All_200_300": 8.0,
		"All_300_400": null,
		"All_400_500": 18.0,
		"All_500_600": 9.0,
		"All_600_700": 7.0,
		"All_700_800": 8.0,
		"All_800_900": 3.0,
		"All_900_1000": 3.0,
		"All_1000_1500": 4.0,
		"All_1500_2000": 4.0,
		"All_2000_2500": 1.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 55.0,
		"Met_15_25": 169.0,
		"Met_25_50": 269.0,
		"Met_50_100": 259.0,
		"Met_100_150": 78.0,
		"Met_150_200": 27.0,
		"Met_200_400": 28.0,
		"Met_400_600": 4.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 0.0,
		"Met_300_400": null,
		"Met_400_500": 3.0,
		"Met_500_600": 1.0,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 1809.0,
		"woFNM_1W": 903.0,
		"woFNM_2L": 782.0,
		"woFNM_2W": 306.0,
		"woFNM_3L": 440.0,
		"woFNM_3W": 118.0,
		"woFNM_4L": 440.0,
		"woFNM_4W": 175.0,
		"woFNM_5L": 439.0,
		"woFNM_5W": 313.0,
		"Met_1L": 528.0,
		"Met_1W": 251.0,
		"Met_2L": 462.0,
		"Met_2W": 289.0,
		"Met_3L": 447.0,
		"Met_3W": 271.0,
		"Met_4L": 436.0,
		"Met_4W": 317.0,
		"Met_5L": 349.0,
		"Met_5W": 263.0,
		"Fib_Fmax1_Fmax": 2009.0,
		"Fib_Fmax1_Lstr": 2407.0,
		"Fib_Fmax2_Fmax": 1786.0,
		"Fib_Fmax2_Lstr": 1968.0,
		"Fib_Lstr1_Fmax": 2009.0,
		"Fib_Lstr1_Lstr": 2407.0,
		"Fib_Fmax_Sum_um": 42415.0,
		"Fib_Stretched_Sum_um": 49858.0,
		"woF_weighted_sum": 6098.0,
		"All_weighted_sum": 13701.0,
		"Met_weighted_sum": 1518.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 129011,
		"Passed": "1",
		"zeichnr": "Deckel",
		"met_sum": 396.0,
		"nm_sum": 1503.0,
		"sum_fibers": 71.0,
		"fibers_sum": 71.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Deckel",
		"betaufnr": 129012,
		"kdnr": 12346,
		"artnr": "5123438",
		"Analysis_No": "129012",
		"Parts_on_Filter": 3.0,
		"Component_Surface_Area_cm2": 35.28,
		"Weight_mg": 0.36,
		"Date_of_arrival": "2021-08-12T15:00:00",
		"Date_of_Extraction": "2021-08-12T15:00:00",
		"Date_of_Analysis": "2021-08-12T15:00:00",
		"Component": "Deckel",
		"Component_No": "XYZ",
		"Testing_Specification": "5123438",
		"customer_no": "12346",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,4 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.642281,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 9310.0,
		"woF_15_25": 4573.0,
		"woF_25_50": 2988.0,
		"woF_50_100": 1244.0,
		"woF_100_150": 297.0,
		"woF_150_200": 122.0,
		"woF_200_400": 73.0,
		"woF_400_600": 6.0,
		"woF_600_1000": 1.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 0.0,
		"woF_300_400": null,
		"woF_400_500": 5.0,
		"woF_500_600": 1.0,
		"woF_600_700": 1.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 9310.0,
		"All_15_25": 4573.0,
		"All_25_50": 2988.0,
		"All_50_100": 1244.0,
		"All_100_150": 297.0,
		"All_150_200": 125.0,
		"All_200_400": 113.0,
		"All_400_600": 20.0,
		"All_600_1000": 22.0,
		"All_gt_1000": 10.0,
		"All_200_300": 8.0,
		"All_300_400": null,
		"All_400_500": 10.0,
		"All_500_600": 10.0,
		"All_600_700": 11.0,
		"All_700_800": 4.0,
		"All_800_900": 4.0,
		"All_900_1000": 3.0,
		"All_1000_1500": 7.0,
		"All_1500_2000": 1.0,
		"All_2000_2500": 1.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 1.0,
		"Met_5_15": 33.0,
		"Met_15_25": 145.0,
		"Met_25_50": 320.0,
		"Met_50_100": 289.0,
		"Met_100_150": 91.0,
		"Met_150_200": 33.0,
		"Met_200_400": 11.0,
		"Met_400_600": 1.0,
		"Met_600_1000": 1.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 0.0,
		"Met_300_400": null,
		"Met_400_500": 1.0,
		"Met_500_600": 0.0,
		"Met_600_700": 1.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 590.0,
		"woFNM_1W": 226.0,
		"woFNM_2L": 496.0,
		"woFNM_2W": 150.0,
		"woFNM_3L": 469.0,
		"woFNM_3W": 124.0,
		"woFNM_4L": 456.0,
		"woFNM_4W": 127.0,
		"woFNM_5L": 422.0,
		"woFNM_5W": 191.0,
		"Met_1L": 664.0,
		"Met_1W": 161.0,
		"Met_2L": 446.0,
		"Met_2W": 64.0,
		"Met_3L": 380.0,
		"Met_3W": 107.0,
		"Met_4L": 306.0,
		"Met_4W": 82.0,
		"Met_5L": 284.0,
		"Met_5W": 64.0,
		"Fib_Fmax1_Fmax": 3026.0,
		"Fib_Fmax1_Lstr": 4836.0,
		"Fib_Fmax2_Fmax": 2340.0,
		"Fib_Fmax2_Lstr": 3420.0,
		"Fib_Lstr1_Fmax": 3026.0,
		"Fib_Lstr1_Lstr": 4836.0,
		"Fib_Fmax_Sum_um": 50034.0,
		"Fib_Stretched_Sum_um": 63893.0,
		"woF_weighted_sum": 5226.0,
		"All_weighted_sum": 13813.0,
		"Met_weighted_sum": 1334.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 129012,
		"Passed": "1",
		"zeichnr": "Deckel",
		"met_sum": 426.0,
		"nm_sum": 1317.0,
		"sum_fibers": 87.0,
		"fibers_sum": 87.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Deckel",
		"betaufnr": 129013,
		"kdnr": 12346,
		"artnr": "5123438",
		"Analysis_No": "129013",
		"Parts_on_Filter": 3.0,
		"Component_Surface_Area_cm2": 35.28,
		"Weight_mg": 0.14,
		"Date_of_arrival": "2021-08-13T15:00:00",
		"Date_of_Extraction": "2021-08-13T15:00:00",
		"Date_of_Analysis": "2021-08-13T15:00:00",
		"Component": "Deckel",
		"Component_No": "XYZ",
		"Testing_Specification": "5123438",
		"customer_no": "12346",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "X:5,4 μm/Pxl   Y:5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.312294,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 4117.0,
		"woF_15_25": 2309.0,
		"woF_25_50": 1453.0,
		"woF_50_100": 514.0,
		"woF_100_150": 118.0,
		"woF_150_200": 28.0,
		"woF_200_400": 30.0,
		"woF_400_600": 6.0,
		"woF_600_1000": 2.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 0.0,
		"woF_300_400": null,
		"woF_400_500": 3.0,
		"woF_500_600": 3.0,
		"woF_600_700": 2.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 4117.0,
		"All_15_25": 2309.0,
		"All_25_50": 1453.0,
		"All_50_100": 514.0,
		"All_100_150": 119.0,
		"All_150_200": 29.0,
		"All_200_400": 31.0,
		"All_400_600": 8.0,
		"All_600_1000": 4.0,
		"All_gt_1000": 3.0,
		"All_200_300": 1.0,
		"All_300_400": null,
		"All_400_500": 5.0,
		"All_500_600": 3.0,
		"All_600_700": 2.0,
		"All_700_800": 1.0,
		"All_800_900": 0.0,
		"All_900_1000": 1.0,
		"All_1000_1500": 1.0,
		"All_1500_2000": 0.0,
		"All_2000_2500": 0.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 2.0,
		"Met_5_15": 30.0,
		"Met_15_25": 94.0,
		"Met_25_50": 101.0,
		"Met_50_100": 43.0,
		"Met_100_150": 29.0,
		"Met_150_200": 8.0,
		"Met_200_400": 5.0,
		"Met_400_600": 2.0,
		"Met_600_1000": 1.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 0.0,
		"Met_300_400": null,
		"Met_400_500": 1.0,
		"Met_500_600": 1.0,
		"Met_600_700": 1.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 627.0,
		"woFNM_1W": 108.0,
		"woFNM_2L": 577.0,
		"woFNM_2W": 189.0,
		"woFNM_3L": 510.0,
		"woFNM_3W": 308.0,
		"woFNM_4L": 441.0,
		"woFNM_4W": 151.0,
		"woFNM_5L": 440.0,
		"woFNM_5W": 193.0,
		"Met_1L": 612.0,
		"Met_1W": 22.0,
		"Met_2L": 565.0,
		"Met_2W": 97.0,
		"Met_3L": 455.0,
		"Met_3W": 276.0,
		"Met_4L": 389.0,
		"Met_4W": 59.0,
		"Met_5L": 385.0,
		"Met_5W": 46.0,
		"Fib_Fmax1_Fmax": 3364.0,
		"Fib_Fmax1_Lstr": 3730.0,
		"Fib_Fmax2_Fmax": 3126.0,
		"Fib_Fmax2_Lstr": 6079.0,
		"Fib_Lstr1_Fmax": 3126.0,
		"Fib_Lstr1_Lstr": 6079.0,
		"Fib_Fmax_Sum_um": 10756.0,
		"Fib_Stretched_Sum_um": 14672.0,
		"woF_weighted_sum": 2390.0,
		"All_weighted_sum": 4035.0,
		"Met_weighted_sum": 583.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 129013,
		"Passed": "1",
		"zeichnr": "Deckel",
		"met_sum": 88.0,
		"nm_sum": 610.0,
		"sum_fibers": 10.0,
		"fibers_sum": 10.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Deckel",
		"betaufnr": 129014,
		"kdnr": 12346,
		"artnr": "5123438",
		"Analysis_No": "129014",
		"Parts_on_Filter": 8.0,
		"Component_Surface_Area_cm2": 35.28,
		"Weight_mg": 0.67,
		"Date_of_arrival": "2021-08-14T15:00:00",
		"Date_of_Extraction": "2021-08-14T15:00:00",
		"Date_of_Analysis": "2021-08-14T15:00:00",
		"Component": "Deckel",
		"Component_No": "XYZ",
		"Testing_Specification": "5123438",
		"customer_no": "12346",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "4,5 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.697744,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 14804.0,
		"woF_15_25": 7170.0,
		"woF_25_50": 5565.0,
		"woF_50_100": 1610.0,
		"woF_100_150": 227.0,
		"woF_150_200": 64.0,
		"woF_200_400": 43.0,
		"woF_400_600": 2.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 0.0,
		"woF_200_300": 0.0,
		"woF_300_400": null,
		"woF_400_500": 1.0,
		"woF_500_600": 1.0,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 0.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 14804.0,
		"All_15_25": 7170.0,
		"All_25_50": 5565.0,
		"All_50_100": 1611.0,
		"All_100_150": 227.0,
		"All_150_200": 67.0,
		"All_200_400": 73.0,
		"All_400_600": 12.0,
		"All_600_1000": 4.0,
		"All_gt_1000": 7.0,
		"All_200_300": 5.0,
		"All_300_400": null,
		"All_400_500": 8.0,
		"All_500_600": 4.0,
		"All_600_700": 3.0,
		"All_700_800": 0.0,
		"All_800_900": 0.0,
		"All_900_1000": 1.0,
		"All_1000_1500": 4.0,
		"All_1500_2000": 1.0,
		"All_2000_2500": 2.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 0.0,
		"Met_5_15": 49.0,
		"Met_15_25": 135.0,
		"Met_25_50": 207.0,
		"Met_50_100": 118.0,
		"Met_100_150": 70.0,
		"Met_150_200": 29.0,
		"Met_200_400": 27.0,
		"Met_400_600": 2.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 0.0,
		"Met_200_300": 0.0,
		"Met_300_400": null,
		"Met_400_500": 1.0,
		"Met_500_600": 1.0,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 0.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 382.0,
		"woFNM_1W": 312.0,
		"woFNM_2L": 357.0,
		"woFNM_2W": 68.0,
		"woFNM_3L": 351.0,
		"woFNM_3W": 49.0,
		"woFNM_4L": 281.0,
		"woFNM_4W": 38.0,
		"woFNM_5L": 232.0,
		"woFNM_5W": 67.0,
		"Met_1L": 514.0,
		"Met_1W": 45.0,
		"Met_2L": 467.0,
		"Met_2W": 149.0,
		"Met_3L": 379.0,
		"Met_3W": 90.0,
		"Met_4L": 374.0,
		"Met_4W": 22.0,
		"Met_5L": 327.0,
		"Met_5W": 42.0,
		"Fib_Fmax1_Fmax": 2245.0,
		"Fib_Fmax1_Lstr": 4644.0,
		"Fib_Fmax2_Fmax": 2115.0,
		"Fib_Fmax2_Lstr": 2635.0,
		"Fib_Lstr1_Fmax": 1400.0,
		"Fib_Lstr1_Lstr": 6205.0,
		"Fib_Fmax_Sum_um": 28250.0,
		"Fib_Stretched_Sum_um": 40582.0,
		"woF_weighted_sum": 3910.0,
		"All_weighted_sum": 8434.0,
		"Met_weighted_sum": 1219.0,
		"Fib_strlength_5_15": null,
		"Fib_strlength_15_25": null,
		"Fib_strlength_25_50": null,
		"Fib_strlength_50_100": null,
		"Fib_strlength_100_150": null,
		"Fib_strlength_150_200": null,
		"Fib_strlength_200_400": null,
		"Fib_strlength_400_600": null,
		"Fib_strlength_600_1000": null,
		"Fib_strlength_gt_1000": null,
		"Fib_strlength_200_300": null,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": null,
		"Fib_strlength_500_600": null,
		"Fib_strlength_600_700": null,
		"Fib_strlength_700_800": null,
		"Fib_strlength_800_900": null,
		"Fib_strlength_900_1000": null,
		"Fib_strlength_1000_1500": null,
		"Fib_strlength_1500_2000": null,
		"Fib_strlength_2000_2500": null,
		"Fib_strlength_2500_3000": null,
		"Fib_strlength_gt_3000": null,
		"analysis_int": 129014,
		"Passed": "1",
		"zeichnr": "Deckel",
		"met_sum": 246.0,
		"nm_sum": 1700.0,
		"sum_fibers": 53.0,
		"fibers_sum": 53.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	},
	{
		"artsuch": "Deckel",
		"betaufnr": 129015,
		"kdnr": 12346,
		"artnr": "5123438",
		"Analysis_No": "129015",
		"Parts_on_Filter": 8.0,
		"Component_Surface_Area_cm2": 35.28,
		"Weight_mg": null,
		"Date_of_arrival": "2021-08-15T15:00:00",
		"Date_of_Extraction": "2021-08-15T15:00:00",
		"Date_of_Analysis": "2021-08-15T15:00:00",
		"Component": "Deckel",
		"Component_No": "XYZ",
		"Testing_Specification": "5123438",
		"customer_no": "12346",
		"Place_of_probe": "nicht bekannt / unknown",
		"Condition_of_delivery": "i.O.",
		"Extraction_Method": null,
		"Extraction_Liquid": null,
		"Amount_Liquid": null,
		"volume_flow": null,
		"nozzle_dimension": null,
		"amount_flushing": null,
		"extraction_equipment": null,
		"Filter_Type": null,
		"filter_diameter": "47 mm",
		"Comment": null,
		"Scale": "5,4 μm/Pxl",
		"Evaluated_diameter_mm": 44.0,
		"occupancy": 0.452484,
		"Fiber_Compactness_Criterion": null,
		"Fiber_Length_Width_Criterion": null,
		"Fiber_Stret_InCircle_criterion": 20.0,
		"Fiber_max_InCircle_criterion": 50.0,
		"woF_5_15": 8568.0,
		"woF_15_25": 3275.0,
		"woF_25_50": 1901.0,
		"woF_50_100": 766.0,
		"woF_100_150": 176.0,
		"woF_150_200": 57.0,
		"woF_200_400": 28.0,
		"woF_400_600": 7.0,
		"woF_600_1000": 0.0,
		"woF_gt_1000": 2.0,
		"woF_200_300": 2.0,
		"woF_300_400": null,
		"woF_400_500": 5.0,
		"woF_500_600": 2.0,
		"woF_600_700": 0.0,
		"woF_700_800": 0.0,
		"woF_800_900": 0.0,
		"woF_900_1000": 0.0,
		"woF_1000_1500": 2.0,
		"woF_1500_2000": 0.0,
		"woF_2000_2500": 0.0,
		"woF_2500_3000": 0.0,
		"woF_gt_3000": 0.0,
		"All_5_15": 8568.0,
		"All_15_25": 3275.0,
		"All_25_50": 1901.0,
		"All_50_100": 766.0,
		"All_100_150": 177.0,
		"All_150_200": 59.0,
		"All_200_400": 55.0,
		"All_400_600": 23.0,
		"All_600_1000": 10.0,
		"All_gt_1000": 22.0,
		"All_200_300": 18.0,
		"All_300_400": null,
		"All_400_500": 13.0,
		"All_500_600": 10.0,
		"All_600_700": 4.0,
		"All_700_800": 1.0,
		"All_800_900": 1.0,
		"All_900_1000": 4.0,
		"All_1000_1500": 12.0,
		"All_1500_2000": 6.0,
		"All_2000_2500": 2.0,
		"All_2500_3000": 0.0,
		"All_gt_3000": 2.0,
		"Met_5_15": 39.0,
		"Met_15_25": 141.0,
		"Met_25_50": 167.0,
		"Met_50_100": 259.0,
		"Met_100_150": 100.0,
		"Met_150_200": 30.0,
		"Met_200_400": 19.0,
		"Met_400_600": 3.0,
		"Met_600_1000": 0.0,
		"Met_gt_1000": 2.0,
		"Met_200_300": 2.0,
		"Met_300_400": null,
		"Met_400_500": 2.0,
		"Met_500_600": 1.0,
		"Met_600_700": 0.0,
		"Met_700_800": 0.0,
		"Met_800_900": 0.0,
		"Met_900_1000": 0.0,
		"Met_1000_1500": 2.0,
		"Met_1500_2000": 0.0,
		"Met_2000_2500": 0.0,
		"Met_2500_3000": 0.0,
		"Met_gt_3000": 0.0,
		"woFNM_1L": 594.0,
		"woFNM_1W": 281.0,
		"woFNM_2L": 500.0,
		"woFNM_2W": 46.0,
		"woFNM_3L": 489.0,
		"woFNM_3W": 128.0,
		"woFNM_4L": 446.0,
		"woFNM_4W": 156.0,
		"woFNM_5L": 319.0,
		"woFNM_5W": 34.0,
		"Met_1L": 1153.0,
		"Met_1W": 84.0,
		"Met_2L": 1137.0,
		"Met_2W": 86.0,
		"Met_3L": 522.0,
		"Met_3W": 70.0,
		"Met_4L": 417.0,
		"Met_4W": 86.0,
		"Met_5L": 407.0,
		"Met_5W": 43.0,
		"Fib_Fmax1_Fmax": 3909.0,
		"Fib_Fmax1_Lstr": 4495.0,
		"Fib_Fmax2_Fmax": 3459.0,
		"Fib_Fmax2_Lstr": 4460.0,
		"Fib_Lstr1_Fmax": 3909.0,
		"Fib_Lstr1_Lstr": 4495.0,
		"Fib_Fmax_Sum_um": 58565.0,
		"Fib_Stretched_Sum_um": 73810.0,
		"woF_weighted_sum": 3679.0,
		"All_weighted_sum": 14597.0,
		"Met_weighted_sum": 2225.0,
		"Fib_strlength_5_15": 0.0,
		"Fib_strlength_15_25": 0.0,
		"Fib_strlength_25_50": 0.0,
		"Fib_strlength_50_100": 0.0,
		"Fib_strlength_100_150": 2.0,
		"Fib_strlength_150_200": 1.0,
		"Fib_strlength_200_400": 23.0,
		"Fib_strlength_400_600": 12.0,
		"Fib_strlength_600_1000": 14.0,
		"Fib_strlength_gt_1000": 24.0,
		"Fib_strlength_200_300": 13.0,
		"Fib_strlength_300_400": null,
		"Fib_strlength_400_500": 5.0,
		"Fib_strlength_500_600": 7.0,
		"Fib_strlength_600_700": 8.0,
		"Fib_strlength_700_800": 3.0,
		"Fib_strlength_800_900": 1.0,
		"Fib_strlength_900_1000": 2.0,
		"Fib_strlength_1000_1500": 6.0,
		"Fib_strlength_1500_2000": 7.0,
		"Fib_strlength_2000_2500": 4.0,
		"Fib_strlength_2500_3000": 5.0,
		"Fib_strlength_gt_3000": 2.0,
		"analysis_int": 129015,
		"Passed": "1",
		"zeichnr": "Deckel",
		"met_sum": 413.0,
		"nm_sum": 623.0,
		"sum_fibers": 74.0,
		"fibers_sum": 74.0,
		"smallest_size_class": "50-100",
		"ioResult": true,
		"zeichindex": "1234"
	}
]
